import React, { Component } from "react";
import { red500 } from "material-ui/styles/colors";
import IconButton from "material-ui/IconButton";
import Paper from "material-ui/Paper";
import _ from "lodash";
import ActionUpdate from "material-ui/svg-icons/editor/mode-edit";
import ActionDelete from "material-ui/svg-icons/action/delete";
import ActionMoveUp from "material-ui/svg-icons/navigation/arrow-drop-up";
import ActionMoveDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import RaisedButton from "material-ui/RaisedButton";
import EmptyIcon from "material-ui/svg-icons/action/view-list";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";
import withFirestorePath from "../components/withFirestorePath";
import DeleteDialog from "../components/DeleteDialog";
import LinearProgress from "../components/LinearProgress";
import placeholderImage from "../images/menu_placeholder.gif";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  saveButton: {
    marginTop: 15,
  },
};

const CategoriesEmpty = ({ onClick }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <EmptyIcon style={{ width: 400, height: 400, color: "#afafaf" }} />
    <h4 style={{ color: "#afafaf" }}>You haven't added any categories</h4>
    <RaisedButton label="Add a Category" secondary onClick={onClick} />
  </div>
);

const CategoriesTable = ({
  restaurantId,
  categories,
  handleDelete,
  moveUpCategory,
  moveDownCategory,
  ...props
}) => {
  return (
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn>Name</TableHeaderColumn>
          <TableHeaderColumn>Photo</TableHeaderColumn>
          <TableHeaderColumn>Edit &amp; Delete</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        {categories.map((category, index) => (
          <TableRow key={index}>
            <TableRowColumn>{category.data().name}</TableRowColumn>
            <TableRowColumn>
              <img
                src={
                  category.data().photoUrl
                    ? category.data().photoUrl
                    : placeholderImage
                }
                style={{ width: 85, height: 64 }}
              />
            </TableRowColumn>
            <TableRowColumn>
              {/* <IconButton onTouchTap={() => moveUpCategory(index)}>
                <ActionMoveUp />
              </IconButton>
              <IconButton onTouchTap={() => moveDownCategory(index)}>
                <ActionMoveDown />
              </IconButton> */}
              <IconButton
                onTouchTap={() =>
                  props.router.push(
                    `/${restaurantId}/edit-category/${category.id}`
                  )
                }
              >
                <ActionUpdate />
              </IconButton>
              <IconButton>
                <ActionDelete
                  color={red500}
                  onClick={() => handleDelete(category)}
                />
              </IconButton>
            </TableRowColumn>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

class Categories extends Component {
  state = {
    categories: null,
    categoryToDelete: null,
    deleteDialogOpen: false,
  };

  async componentDidMount() {
    this.fetchData();
  }

  moveUpCategory = (index) => {};

  moveDownCategory = (index) => {};

  async fetchData() {
    const { restaurantPath } = this.props;
    try {
      const categorySnaps = await restaurantPath
        .collection("category")
        .orderBy("name")
        .get();

      const categories = categorySnaps.docs;

      this.setState({
        categories,
      });
    } catch (e) {
      console.log({ e });
    }
  }

  closeDeleteDialog() {
    this.setState({
      deleteDialogOpen: false,
    });
  }

  handleDeleteDialogClose = () => {
    this.closeDeleteDialog();
  };

  handleDeleteCategory = (category) => {
    this.setState({
      categoryToDelete: category,
      deleteDialogOpen: true,
    });
  };

  handleConfirmDelete = async () => {
    const { restaurantPath } = this.props;
    const { categoryToDelete } = this.state;
    await restaurantPath
      .collection("category")
      .doc(categoryToDelete.id)
      .delete();
    this.setState({
      deleteDialogOpen: false,
      categoryToDelete: null,
    });
    this.fetchData();
  };

  renderDeleteDialog() {
    const { categoryToDelete, deleteDialogOpen } = this.state;
    return (
      <DeleteDialog
        title="Delete Category"
        open={deleteDialogOpen}
        onRequestClose={this.handleDeleteDialogClose}
        onConfirm={this.handleConfirmDelete}
        onDismiss={this.handleDeleteDialogClose}
      >
        {`Are you sure you want to delete '${
          categoryToDelete &&
          categoryToDelete.data &&
          categoryToDelete.data().name
        }'? This action cannot be undone.`}
      </DeleteDialog>
    );
  }

  render() {
    const { categories } = this.state;

    const { params } = this.props;
    const restaurantId = params.restaurantId;

    if (!categories) return <LinearProgress secondary />;

    if (_.isEmpty(categories)) {
      return (
        <div style={styles.root}>
          <CategoriesEmpty
            onClick={() =>
              this.props.router.push(`/${restaurantId}/create-category`)
            }
          />
        </div>
      );
    }

    return (
      <div style={styles.root}>
        <h1>Categories</h1>
        <RaisedButton
          style={{ marginBottom: 5 }}
          label="Add Category"
          onTouchTap={() =>
            this.props.router.push(`/${restaurantId}/create-category`)
          }
          secondary
        />
        <Paper style={styles.paper}>
          <CategoriesTable
            {...this.props}
            moveDownCategory={this.moveDownCategory}
            moveUpCategory={this.moveUpCategory}
            categories={categories}
            restaurantId={restaurantId}
            handleDelete={this.handleDeleteCategory}
          />
        </Paper>
        {this.renderDeleteDialog()}
      </div>
    );
  }
}

export default withFirestorePath(Categories);



// WEBPACK FOOTER //
// ./src/pages/Categories.js